/**
 * @Description 踩点记录 列表
 */

import { FC } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { getSpotSurveySimplePage } from '@/common/api/expandStore/spotSurvey';
import { isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';

const List: FC<{
  filters,
  onClickDetail;
  setLoading;
  setHasData?: any;
  setLoaded?: any;
}> = ({ filters, setLoading, onClickDetail, setHasData, setLoaded }) => {

  const defaultColumns = [
    {
      title: '踩点编号',
      dataIndex: 'code',
      key: 'code',
      width: 120,
      render: (value, record) => {
        return <a onClick={() => onClickDetail(record)} style={{ color: '#2441B3' }}>{value}</a>;
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 80,
    },
    {
      title: '踩点位置',
      dataIndex: 'address',
      key: 'address',
      width: 100,
    },
  ];

  const methods = useMethods({
    /**
     * @description 获取加载table表格数据。该函数依赖fitles变化自动触发
     * @param params fitles和搜索框参数（当前页面只有keyword）
     * @return table数据
     */
    async loadData(params: any) {
      if (!isNotEmptyAny(filters)) return;
      const data = await getSpotSurveySimplePage({ ...params, ...filters }).finally(() => {
        setLoading(false);
      });
      setLoading(false);
      setLoaded(true);
      setHasData(!!data.totalNum);
      return {
        dataSource: data.objectList || [],
        count: data.totalNum,
      };
    }
  });

  return (
    <V2Table
      filter={filters}
      defaultColumns={defaultColumns}
      onFetch={methods.loadData}
      hideColumnPlaceholder
      voluntarilyEmpty
      rowKey='id'
      pageSize={10}
      scroll={{ y: 400, x: 'max-content' }}
    />
  );
};

export default List;
